import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Box from "ds/components/Box";
import Tab from "ds/components/Tab";
import TooltipInfo from "ds/components/TooltipInfo";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";

const UsageLayoutHeader = () => (
  <PageInfoHeaderWrapper align="start">
    <Box direction="column">
      <Box direction="row" align="center" gap="small">
        <PageInfoHeaderTitle title="Usage" />
        <TooltipInfo widthMode="maxWidthSm">Computed live from this instance.</TooltipInfo>
      </Box>

      <ViewHeaderNavigation>
        <Tab to="../workers" label="Workers" />
        <Tab to="../runs" label="Runs" />
      </ViewHeaderNavigation>
    </Box>
  </PageInfoHeaderWrapper>
);

export default UsageLayoutHeader;
